import useViewport from "../../../Utilities/useViewport";
import TabNav from "./TabNav";
import MobileTabNav from "./MobileTabNav";
import { SetNavigationTab } from "../../../actions/teacherTabNavActions";
import { useDispatch, useSelector } from "react-redux";

export default function TabNavSelector(props) {
  const { width } = useViewport();
  const breakpoint = 620;

  const dispatch = useDispatch();
  const handlePostNavTab = (tab) => {
    dispatch(SetNavigationTab(tab));
  };
  const tab = useSelector((state) => state.teacherTabNavReducer);

  const NavTabsOnlyInClass = [5, 6];
  if (props.level !== "class" && NavTabsOnlyInClass.includes(tab.tab)) {
    handlePostNavTab(1);
  }
  return width < breakpoint ? (
    <MobileTabNav
      level={props.level}
      handlePostNavTab={handlePostNavTab}
      tab={tab.tab}
    />
  ) : (
    <TabNav
      level={props.level}
      handlePostNavTab={handlePostNavTab}
      tab={tab.tab}
    />
  );
}
